import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCloudArrowDown,
  faGlobe
} from "@fortawesome/free-solid-svg-icons";

import {
  faInstagram,
  faYoutube,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";

import React, { useContext, useState } from 'react';
import { Context } from "../contexts/AppContext";
import PhotoButton from './PhotoButton';

const LinkMediaVideoHeader = ({ appState }) => {

  const { value } = useContext(Context);
  const [appState1, setAppState] = value;

  const [showCompanyPopup, setShowCompanyPopup] = useState(false);

  // ✅ FIX SOCIAL URLS
  const formatUrl = (url) => {
    if (!url) return "#";

    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };

  const qrBtnClk = () => {
    setAppState((prevState) => {
      return {
        ...prevState,
        modalData: {
          ...prevState.modalData,
          type: "QrCodeModal",
          isOpen: true
        }
      };
    });
  };

  const downloadBtnClk = () => {
    setAppState((prevState) => {
      return {
        ...prevState,
        modalData: {
          ...prevState.modalData,
          type: "DownloadVideoModal",
          isOpen: true
        }
      };
    });
  };

  const watchOnTvBtnClk = () => {
    setAppState((prevState) => {
      return {
        ...prevState,
        modalData: {
          ...prevState.modalData,
          type: "WatchOnTvModal",
          isOpen: true
        }
      };
    });
  };

  const shareBtnClk = () => {
    const currentUrl = window.location.href;

    navigator.clipboard.writeText(currentUrl)
      .then(() => {
        alert('URL copied to clipboard!');
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <>
      <header className="p-4">
        <div className="flex justify-between items-center sm:h-16 w-[90vw] sm:w-[98vw]">

          {/* LEFT SECTION */}
          <div>
            <div className="flex items-center flex-col sm:flex-row">

              {/* COMPANY LOGO */}
              <div
                onClick={() => setShowCompanyPopup(true)}
                className="w-12 h-12 md:w-[70px] md:h-[70px] rounded-full mx-auto mb-1 bg-white overflow-hidden cursor-pointer border border-gray-200 hover:scale-105 transition-all duration-200 shadow-sm"
              >
                <img
                  src={
                    appState?.adminDetails?.companyLogoUrl
                      ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.adminDetails?.companyLogoUrl}?width=960&height=960&optimize=photo`
                      : "/img/logo.webp"
                  }
                  alt="Company Logo"
                  className="w-full h-full object-contain"
                />
              </div>

              {/* COMPANY NAME */}
              <div className="flex flex-col items-center sm:items-start sm:ml-2">
                <div
                  className="w-full text-sm md:text-sm text-black font-thin md:my-2 brand-name-shadow"
                  style={{
                    fontFamily: appState.currentFontFamilyLogoTxt,
                    color: appState.currentLogoColor,
                    fontSize: `${appState.currentLogoFontSize}px`,
                  }}
                >
                  {appState?.adminDetails?.companyName}
                </div>
              </div>

            </div>
          </div>

          {/* RIGHT BUTTONS */}
          <div className="flex items-center gap-2 px-6">

            {/* QR BUTTON */}
            {/* <button
              onClick={qrBtnClk}
              className="flex items-center justify-center text-white rounded-full bg-gray-900
                         w-10 h-10 md:w-12 md:h-12 hover:bg-[#6a6a6a] transition-all duration-200"
              title="Show QR Code"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M3 3h8v8H3V3zm2 2v4h4V5H5zm6-2h8v8h-8V3zm2 2v4h4V5h-4zM3 13h8v8H3v-8zm2 2v4h4v-4H5zm10-2h2v2h-2v-2zm0 4h2v2h-2v-2zm-4-4h2v2h-2v-2zm4 4h2v2h-2v-2zm2 2h2v2h-2v-2z"/>
              </svg>
            </button> */}

            {/* PHOTO BUTTON */}
            {appState?.photos?.length > 0 && <PhotoButton />}

            {/* TV BUTTON */}
            {appState?.currentGalleryData?.setting?.tv && (
              <button
                id="gallery-tv-connect"
                onClick={watchOnTvBtnClk}
                className="flex gap-1 items-center justify-center text-white rounded-full bg-gray-900
                           w-10 h-10 md:w-12 md:h-12 hover:bg-[#6a6a6a] transition-all duration-200"
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="tv"
                  className="w-3 h-3"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 640 512"
                >
                  <path
                    fill="currentColor"
                    d="M64 64l0 288 512 0 0-288L64 64zM0 64C0 28.7 28.7 0 64 0L576 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 416c-35.3 0-64-28.7-64-64L0 64zM128 448l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-384 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"
                  />
                </svg>

                <span className="text-xs">TV</span>
              </button>
            )}

            {/* DOWNLOAD BUTTON */}
            {appState?.currentGalleryData?.setting?.download && (
              <>
                
              <button
                onClick={downloadBtnClk}
                className="flex items-center justify-center text-white rounded-full bg-gray-900
                           w-10 h-10 md:w-12 md:h-12 hover:bg-[#6a6a6a] transition-all duration-200"
              >
                <FontAwesomeIcon icon={faCloudArrowDown} className="w-5 h-5" />
                
              </button>
              </>
            )}

            {/* SHARE BUTTON */}
            {appState?.currentGalleryData?.setting?.share && (
              <button
                onClick={shareBtnClk}
                className="flex items-center justify-center text-white rounded-full bg-gray-900
                           w-10 h-10 md:w-12 md:h-12 hover:bg-[#6a6a6a] transition-all duration-200"
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fas"
                  data-icon="share-nodes"
                  className="w-4 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512"
                >
                  <path
                    fill="currentColor"
                    d="M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z"
                  />
                </svg>
              </button>
            )}

          </div>
        </div>
      </header>

      {/* COMPANY SOCIAL POPUP */}
      {showCompanyPopup && (
        <div
          className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[9999] px-4"
          onClick={() => setShowCompanyPopup(false)}
        >

          <div
            className="bg-red-600 rounded-[30px] p-6 w-full max-w-md shadow-2xl animate-fadeIn"
            onClick={(e) => e.stopPropagation()}
          >

            {/* TOP SECTION */}
            <div className="flex flex-col items-center">

              <div className="w-28 h-28 rounded-full overflow-hidden bg-gray-100 mb-4 shadow-lg border-4 border-white">
                <img
                  src={
                    appState?.adminDetails?.companyLogoUrl
                      ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${appState?.adminDetails?.companyLogoUrl}?width=960&height=960&optimize=photo`
                      : "/img/logo.webp"
                  }
                  alt="logo"
                  className="w-full h-full object-contain"
                />
              </div>

              <h2 className="text-2xl font-bold text-white text-center">
                {appState?.adminDetails?.companyName}
              </h2>

              <p className="text-sm text-white mt-2 text-center">
                Connect with us on social platforms
              </p>

            </div>

            {/* SOCIAL LINKS */}
         <div className="flex items-center justify-center gap-4 mt-8 flex-wrap">

  {/* INSTAGRAM */}
  {appState?.adminDetails?.socialLinks?.instagram && (
    <a
      href={formatUrl(appState?.adminDetails?.socialLinks?.instagram)}
      target="_blank"
      rel="noreferrer"
      className="group"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl">

        <FontAwesomeIcon
          icon={faInstagram}
          className="text-white text-3xl"
        />

      </div>
    </a>
  )}

  {/* YOUTUBE */}
  {appState?.adminDetails?.socialLinks?.youtube && (
    <a
      href={formatUrl(appState?.adminDetails?.socialLinks?.youtube)}
      target="_blank"
      rel="noreferrer"
      className="group"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-500 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl">

        <FontAwesomeIcon
          icon={faYoutube}
          className="text-white text-3xl"
        />

      </div>
    </a>
  )}

  {/* FACEBOOK */}
  {appState?.adminDetails?.socialLinks?.facebook && (
    <a
      href={formatUrl(appState?.adminDetails?.socialLinks?.facebook)}
      target="_blank"
      rel="noreferrer"
      className="group"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-600 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl">

        <FontAwesomeIcon
          icon={faFacebook}
          className="text-white text-3xl"
        />

      </div>
    </a>
  )}

  {/* WEBSITE */}
  {appState?.adminDetails?.website && (
    <a
      href={formatUrl(appState?.adminDetails?.website)}
      target="_blank"
      rel="noreferrer"
      className="group"
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-gray-800 shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-2xl">

        <FontAwesomeIcon
          icon={faGlobe}
          className="text-white text-3xl"
        />

      </div>
    </a>
  )}

</div>

            {/* CLOSE BUTTON */}
            <button
              onClick={() => setShowCompanyPopup(false)}
              className="group relative mt-8 w-full overflow-hidden rounded-3xl bg-black py-4 font-semibold text-white transition-all duration-300 hover:scale-[1.02]"
            >
              <span className="relative z-10 flex items-center justify-center gap-2 text-base">
                ✕ Close
              </span>

              <div className="absolute inset-0 bg-gradient-to-r from-gray-800 to-black opacity-0 transition-opacity duration-300 group-hover:opacity-100"></div>
            </button>

          </div>
        </div>
      )}
    </>
  );
};

export default LinkMediaVideoHeader;